import { render } from "./PopupComponent.vue?vue&type=template&id=461913ea"
import script from "./PopupComponent.vue?vue&type=script&lang=js"
export * from "./PopupComponent.vue?vue&type=script&lang=js"

import exportComponent from "/opt/build/repo/node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__